<span class="rate" [class]="this.size" [class.disabled]="disabled">
  @for (star of stars; track star) {
    <i
      tabindex="0"
      [className]="numStarsSelected >= star ? 'selected' : ''"
      (click)="ratingSelected.emit(star)"
      (keydown.enter)="ratingSelected.emit(star)">★
    </i>
  }
</span>
